<template>
  <div>
    <el-dialog title="修改签署密码" :visible.sync="dialogVisible" width="450px" :close-on-click-modal="false" :before-close="handleClose" @close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
        <el-form-item prop="oldCode" label="旧密码">
          <el-input show-password v-model="ruleForm.oldCode" placeholder="请输入原独立签署密码"></el-input>
        </el-form-item>
        <el-form-item prop="newCode" label="新密码">
          <el-input show-password v-model="ruleForm.newCode" placeholder="请设置新独立签署密码"></el-input>
        </el-form-item>
        <el-form-item prop="confirmCode" label="确认密码">
          <el-input show-password v-model="ruleForm.confirmCode" placeholder="请输入确认独立签署密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="sub-button" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var validNewPass = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if (value === "") {
        callback(new Error("请设置新独立签署密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码必须为6位数字"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请输入确认独立签署密码"));
      } else if (value !== this.ruleForm.newCode) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      ruleForm: {
        oldCode: undefined,
        newCode: undefined,
        confirmCode: undefined
      },
      rules: {
        oldCode: [
          { required: true, message: '请输入原独立签署密码', trigger: "blur" }
        ],
        newCode: [
          { required: true, validator: validNewPass, trigger: "blur" }
        ],
        confirmCode: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ]
      },
      loading: false
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate(value => {
        if (value) {
          this.$http.post(this.$api.user.changePinCode, this.ruleForm).then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg)
              this.handleClose()
            } else {
                this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    handleClose() {
      this.loading = false;
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.sub-button {
  width: 138px;
  height: 42px;
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 30px 0;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
